<template>
  <div class="header border-bottom">
    <a href="/">
      <img
        src="../assets/img/logo.svg"
        class="logo"
        alt="logo"
      >
    </a>
    <span>
      Besoin d’aide ? <br class="d-md-none">
      <a
        class="text-primary"
        href="tel:03 89 37 75 00"
      >
        03 89 37 75 00
      </a>
    </span>
  </div>
</template>

<script>
export default {
  name: "TopNav"
}
</script>